import { render, staticRenderFns } from "./RazorpayCheckout.vue?vue&type=template&id=8c1122ea&scoped=true"
import script from "./RazorpayCheckout.vue?vue&type=script&lang=js"
export * from "./RazorpayCheckout.vue?vue&type=script&lang=js"
import style0 from "./RazorpayCheckout.vue?vue&type=style&index=0&id=8c1122ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1122ea",
  null
  
)

export default component.exports